// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {reduxForm} from 'redux-form'
import Checkbox from '@material-ui/core/Checkbox'
import {checkItems, changeCheckAllBoxState} from '../../../actions/table'
// Icons
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'

import './index.css'

class UpdateForm extends Component {
  componentDidUpdate (prevProps) {
    if (prevProps.table.checkAll !== this.props.table.checkAll) {
      let checked = this.isChecked()
      if (!checked && this.props.table.checkAll) {
        this.props.checkItems(this.props.item, this.props.formNumber)
      } else if (checked && prevProps.table.checkAll && !this.props.table.checkAll) {
        this.props.checkItems(this.props.item, this.props.formNumber)
      }
    }
  }

  isChecked = () => {
    const {formNumber, table} = this.props
    return table.checkedItems ? table.checkedItems[formNumber] != null : false
  }

  onCheckChange = () => {
    let checked = this.isChecked()
    let {checkAll} = this.props.table
    if (!checked && checkAll) {
      this.props.changeCheckAllBoxState(true, false)
    }
  }

  renderFormFields = () => {
    const {fields} = this.props
    if (!fields) {
      return null
    }
    let formFields = fields.map((field) => {
      return ({field})
    })

    return formFields
  }

  renderExtraButtons = () => {
    if (!this.props.extraButtons) {
      return null
    }
    return this.props.extraButtons
  }

  render () {
    const {handleSubmit, submitting, invalid, reset, fields, updateButtons, item, checkBoxes, formNumber, pristine} = this.props
    const checked = this.isChecked()

    return (
      <form className='tr update-form padding-30 row' onSubmit={handleSubmit}>
        { checkBoxes &&
        <div className='th col-1 user-icon'><Checkbox onChange={() => {this.props.checkItems(item, formNumber); this.onCheckChange()}} checked={checked}/></div>
        }
        {fields(item)}
        <div className='td form-buttons column-buttons col-1'>
          <div className='button save'>
            <button className='save-button' type='submit' disabled={pristine || submitting || invalid}><CheckCircleOutlineOutlinedIcon/>&nbsp; Save</button>
          </div>
          <div className='button cancel'>
            <button className='cancel-button' type='button' onClick={() => {reset(); this.props.showEditForm()}}><CancelOutlinedIcon/>&nbsp; Cancel</button>
          </div>
          {updateButtons && updateButtons(item)}
        </div>
      </form>
    )
  }
}

function validate (values, props) {
  return props.validate(values)
}

function onSubmit (values, dispatch, props) {
  dispatch(props.onSubmit(values))
}

function mapStateToProps ({userManagement, table}) {
  return {
    editing: userManagement.editing,
    table: table
  }
}

const UpdateFormRedux = connect(mapStateToProps, {checkItems, changeCheckAllBoxState})(UpdateForm)

export default reduxForm({
  onSubmit: onSubmit,
  validate: validate
})(UpdateFormRedux)
